module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .fields-block {\n        margin: auto;\n        width: 70%;\n        /*height: 100%;*/\n    }\n</style>\n<div class=\"fields-block\">\n    ")
    ;  for (var i = 0; i < widget.editor.length; i++) { 
    ; __append("\n        ")
    ;  var editor = widget.editor[i]; 
    ; __append("\n        <div class=\"section\">\n            <control ")
    ; __append( Html.attributes(editor) )
    ; __append(" />\n        </div>\n    ")
    ;  } 
    ; __append("\n        <div name=\"form-controls\">\n\n        </div>\n</div>\n\n")
  }
  return __output.join("");

}